//CAMBIAR URL_API_APP SEGÚN AMBIENTE
// export const APIURL = `${URL_API_APP}/mad`;
 export const APIURL = "https://asistente.coopeuch.cl/mad";
// export const APIURL = "http://127.0.0.1:5000"
// export const APIURL = "https://qa-coopeuch.mycognitiva.io/back"
// export const APIURL = "https://ivic-coopeuch.mycognitiva.io/mad";

